import { isBrowser } from './browser';
var PX_SUFFIX = 'px';
export function setDOMSize($el, width, height) {
  // @ts-ignore
  if (isBrowser && $el.style) {
    // @ts-ignore
    $el.style.width = width + PX_SUFFIX; // @ts-ignore

    $el.style.height = height + PX_SUFFIX;
  }
}